import { render, staticRenderFns } from "./CreatedOrEditedTruck.vue?vue&type=template&id=02f6e35c&scoped=true&"
import script from "./CreatedOrEditedTruck.vue?vue&type=script&lang=js&"
export * from "./CreatedOrEditedTruck.vue?vue&type=script&lang=js&"
import style0 from "./CreatedOrEditedTruck.vue?vue&type=style&index=0&id=02f6e35c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f6e35c",
  null
  
)

export default component.exports